/**
 * PCM Email Typo Suggestions
 *
 * A small, dependency-free reimplementation of the Mailcheck library
 * (Levenshtein distance against a list of common email domains) plus a
 * jQuery `.mailcheck()` plugin shim, for forms that suggest "did you mean
 * gmail.com?" on a misspelled email domain. Only defines `window.Mailcheck`
 * / `$.fn.mailcheck` if nothing has already provided them.
 */
(function(window, $) {
  'use strict';

  const commonEmailDomains = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
    'comcast.net',
    'verizon.net',
    'att.net',
    'msn.com',
    'live.com',
    'me.com',
    'mac.com',
    'cox.net',
    'bellsouth.net',
    'ymail.com',
    'earthlink.net'
  ];

  function levenshteinDistance(a, b) {
    const matrix = [];
    let i;
    let j;

    if (a === b) {
      return 0;
    }

    if (!a.length) {
      return b.length;
    }

    if (!b.length) {
      return a.length;
    }

    for (i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }

    for (j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (i = 1; i <= b.length; i++) {
      for (j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  function getMailSuggestion(email, domains) {
    const trimmedEmail = String(email || '').trim().toLowerCase();
    const parts = trimmedEmail.split('@');

    if (parts.length !== 2 || !parts[0] || !parts[1]) {
      return false;
    }

    const domain = parts[1];
    const availableDomains = domains || commonEmailDomains;
    let closestDomain = '';
    let closestDistance = 3;

    for (let i = 0; i < availableDomains.length; i++) {
      if (domain === availableDomains[i]) {
        return false;
      }

      const distance = levenshteinDistance(domain, availableDomains[i]);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestDomain = availableDomains[i];
      }
    }

    if (!closestDomain || closestDistance > 2) {
      return false;
    }

    return {
      address: parts[0],
      domain: closestDomain,
      full: parts[0] + '@' + closestDomain
    };
  }

  const Mailcheck = window.Mailcheck || {};
  Mailcheck.suggest = Mailcheck.suggest || function(email, domains) {
    return getMailSuggestion(email, domains);
  };
  Mailcheck.run = Mailcheck.run || function(options) {
    const suggestion = Mailcheck.suggest(options.email, options.domains);

    if (suggestion && typeof options.suggested === 'function') {
      return options.suggested(suggestion);
    }

    if (!suggestion && typeof options.empty === 'function') {
      return options.empty();
    }

    return suggestion;
  };
  window.Mailcheck = Mailcheck;

  function initMailcheckPlugin() {
    if (!$ || !$.fn || $.fn.mailcheck) {
      return;
    }

    $.fn.mailcheck = function(options) {
      return this.each(function() {
        const $field = $(this);
        const config = $.extend({}, options, {
          email: $field.val()
        });

        if (typeof options.suggested === 'function') {
          config.suggested = function(suggestion) {
            options.suggested($field, suggestion);
          };
        }

        if (typeof options.empty === 'function') {
          config.empty = function() {
            options.empty($field);
          };
        }

        Mailcheck.run(config);
      });
    };
  }

  if ($) {
    $(initMailcheckPlugin);
  }
})(window, window.jQuery);
